let errors = {};

if (process.env.NODE_ENV === 'development') {
  errors = {
    USEC1:
      'ReactstrapOverlayTrigger instantiated with a non styled-component or DOM node as child',
    USEC4:
      'UserListItem.resendInvitation called with empty invitation or invitation URL',
    USEC5:
      'VersionsSidebar.deleteVersion called for selected version and no other version was available to be selected',
    USEC7:
      'ProcedureList.onRemoveProcedure called but the procedure wasnt found on process.memberships',
    USEC8:
      'removeUserFromTeam called but the teams couldnt be found on user.team_memberships',
    USEC9:
      'getDatesFromValue called with a slug value but couldnt be found in the list of valid slugs',
    USEC10:
      'TasksDueFilter.setPredefinedValue called with a slug value but it could not be found in the list of valid slugs',
    USEC12:
      "ProcedureProcessesSidebar.onRemove called but membership wasn't found",
    USEC13:
      'BaseWrapStaticContentPage.children was used but no "#static-page-children-placeholder" DOM node was found',
  };
}

export function getErrorDescription(errorCode: string) {
  return errorCode in errors
    ? errors[errorCode]
    : `Unexpected State Error code ${errorCode}`;
}
